import { ROLES } from '../AppConstants';
import { userHasRoleAccess } from '../helpers/AccessManagementHelpers';
import { useGetUserQuery } from '../services/rtk/AuthAPI';
import { useGetEvaluatedSettingsQuery } from '../services/rtk/SettingsAPI';
import { ROLE_NAME } from '../types/User';

type ViewName = 'settings';
type ViewAccess = { canView: boolean; isLoading: boolean };

export const useCanView = (view: ViewName, allowedRoles?: readonly ROLE_NAME[]): ViewAccess => {
    const { data: user, isLoading: isLoadingUser } = useGetUserQuery();
    const { data: settings, isLoading: isLoadingSettings } = useGetEvaluatedSettingsQuery();

    const hasRoleAccess = userHasRoleAccess(user, allowedRoles);
    const hasViewAccess = settings?.visibleViews?.includes(view) ?? false;
    const canView = hasRoleAccess || hasViewAccess;

    return { canView, isLoading: isLoadingUser || isLoadingSettings };
};

export const useCanViewSettings = (): ViewAccess => useCanView('settings', [ROLES.ADMIN]);
